module.exports = __webpack_public_path__ + "static/media/bio_fiona_3.e1ac423d.jpg";